import { callApi } from 'utils/api/callApi'
import { FP_ENDPOINTS } from 'apps/fleet-planner/config'
import * as Types from 'apps/fleet-planner/types'

export const fetchActivityList = (loadId: string): Promise<Types.IGetActivityResponse> => {
  return callApi({
    endpoint: `${FP_ENDPOINTS.shipments}/${loadId}/activities`,
    method: 'GET',
  })
}
